import React from 'react';
import { ListItemIcon, Divider, ListItemText, ListItem, Typography, Avatar } from "@mui/material";
import { useIntl } from 'react-intl';
import { useSelector } from "react-redux";
import { getLastConnection } from '../../tools/getLastConn';

const FsmAvatarDriver = (props) => {

    const { driver } = props;
    const { messages, locale } = useIntl();
    const { user: { dateformat } } = useSelector((state) => state.securityRedux);
    let color = (driver?.connected) ? 'fsmAvatarConnected' : '';

    let lastConnected = getLastConnection(driver, dateformat, messages, locale) 
    
    return (

        <div className="contaier_messages_avatar" >

            <ListItem
                className='fsmDriverItem'
            >
                <ListItemIcon>
                    <Avatar className="fsmDriverAvatarItem" className={color}>
                        {driver?.name[0]?.toUpperCase()}
                    </Avatar>
                </ListItemIcon>
                <ListItemText >
                    <Typography color="inherit"  >
                        {driver?.name}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" style={{ fontSize: 12 }}>
                        {messages['FSM_SETTINGS_MESSAGES_UNIT']}  {driver?.unit?.label} / {messages['FSM_SETTINGS_MESSAGES_DRIVER_STATUS']}   {driver?.driverStatus}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" style={{ fontSize: 12 }}>
                    {messages['FSM_SETTINGS_MESSAGES_LAST_CONNECTION']} {lastConnected}
                    </Typography>
                </ListItemText>
            </ListItem>
            <Divider />
        </div>

    );
};

export default FsmAvatarDriver;
